import { UpdateUserPage } from '~/components/pages/UpdateUserPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';
import { useApi } from '~/lib/api';

export const UpdateUserRoute: React.FC = () => {
  const api = useApi();
  const navigate = useNavigate();
  const currentUserId = api.getCurrentUserId();

  if (!currentUserId) {
    navigate('^/login');

    return null;
  }

  return (
    <DashboardTemplate>
      <UpdateUserPage userId={currentUserId} />
    </DashboardTemplate>
  );
};
